/**
 * @generated SignedSource<<1e9e2fb117cbdd563a16c6aab988c12f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionsHelmetFragment$data = {
  readonly name: string;
  readonly slug: string;
  readonly versionsHelmet: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly publishedAt: DateTime | null | undefined;
      readonly version: Semver;
    }>;
  };
  readonly " $fragmentType": "DatasetVersionsHelmetFragment";
};
export type DatasetVersionsHelmetFragment$key = {
  readonly " $data"?: DatasetVersionsHelmetFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionsHelmetFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionsHelmetFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": "versionsHelmet",
      "args": null,
      "concreteType": "DatasetVersionConnection",
      "kind": "LinkedField",
      "name": "versions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DatasetVersion",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publishedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Dataset",
  "abstractKey": null
};

(node as any).hash = "796c7c1fbad937865b2860dcb127c5c3";

export default node;
